import angular from 'angular';

angular.module('eCareVault.common.share', []);
